CopyCoverSections = {
  init: function(container, targetSectionsData, messages) {
    this.container = container;
    this.targetSectionsData = targetSectionsData;
    this.messages = messages || {};

    this.bindSelectAllCheckboxes();
    this.bindFieldCheckboxes();
    this.bindTargetActionRadios();
    this.bindTargetSectionSelects();
    this.bindFormValidation();
  },

  bindSelectAllCheckboxes: function() {
    let container = this.container;
    container.querySelectorAll('.js-select-all-checkbox').forEach(function(selectAll) {
      selectAll.addEventListener('change', function() {
        let sectionIdx = this.dataset.section;
        let checkboxes = container.querySelectorAll('.js-section-' + sectionIdx + '-field');
        checkboxes.forEach(function(cb) { cb.checked = selectAll.checked; });
      });
    });
  },

  bindFieldCheckboxes: function() {
    let container = this.container;
    container.querySelectorAll('.js-field-checkbox').forEach(function(cb) {
      cb.addEventListener('change', function() {
        let sectionClass = CopyCoverSections.findSectionClass(this.className);
        if (!sectionClass) return;

        let sectionIdx = sectionClass.match(/js-section-(\d+)-field/)[1];
        let allCheckboxes = container.querySelectorAll('.js-section-' + sectionIdx + '-field');
        let allChecked = Array.from(allCheckboxes).every(function(c) { return c.checked; });
        let selectAll = container.querySelector('.js-select-all-checkbox[data-section="' + sectionIdx + '"]');
        if (selectAll) selectAll.checked = allChecked;
      });
    });
  },

  bindTargetActionRadios: function() {
    let container = this.container;
    let _this = this;
    container.querySelectorAll('.js-target-action-radio').forEach(function(radio) {
      radio.addEventListener('change', function() {
        let sectionIdx = this.dataset.section;
        let selectEl = container.querySelector('.js-section-' + sectionIdx + '-target');
        let previewEl = container.querySelector('.js-section-' + sectionIdx + '-preview');
        let isExisting = this.value === 'existing';

        if (selectEl) {
          selectEl.disabled = !isExisting;
        }
        if (previewEl) {
          previewEl.style.display = isExisting ? 'block' : 'none';
          if (isExisting && selectEl) {
            _this.renderTargetSectionPreview(sectionIdx, selectEl.value);
          }
        }
      });
    });
  },

  bindTargetSectionSelects: function() {
    let _this = this;
    $(this.container).find('.js-target-section-select').on('change', function() {
      let sectionClass = CopyCoverSections.findSectionClass(this.className, /^js-section-(\d+)-target$/);
      if (!sectionClass) return;

      let sectionIdx = sectionClass.match(/js-section-(\d+)-target/)[1];
      _this.renderTargetSectionPreview(sectionIdx, this.value);
    });
  },

  bindFormValidation: function() {
    let container = this.container;
    let messages = this.messages;
    container.addEventListener('submit', function(e) {
      let anyChecked = container.querySelectorAll('.js-field-checkbox:checked').length > 0;
      if (!anyChecked) {
        e.preventDefault();
        alert(messages.selectAtLeastOne);
      }
    });
  },

  renderTargetSectionPreview: function(sectionIdx, targetSectionId) {
    let previewBody = this.container.querySelector('.js-section-' + sectionIdx + '-preview .js-target-preview-body');
    if (!previewBody || !this.targetSectionsData.length) return;

    let sectionData = this.targetSectionsData.find(function(s) { return s.id === targetSectionId; });
    if (!sectionData || !sectionData.fields || sectionData.fields.length === 0) {
      previewBody.innerHTML = '<tr><td colspan="2" style="color: #999; font-style: italic;">' + CopyCoverSections.escapeHtml(this.messages.noFieldsYet) + '</td></tr>';
      return;
    }

    let html = '';
    sectionData.fields.forEach(function(field) {
      let label = CopyCoverSections.escapeHtml(field.label || '');
      let displayValue = CopyCoverSections.escapeHtml(field.display_value || '');
      html += '<tr><td>' + label + '</td><td><code>' + displayValue + '</code></td></tr>';
    });
    previewBody.innerHTML = html;
  },

  findSectionClass: function(className, pattern) {
    pattern = pattern || /^js-section-\d+-field$/;
    let classes = className.split(' ');
    return classes.find(function(c) { return c.match(pattern); });
  },

  escapeHtml: function(text) {
    let div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
